import {RelativeDate, TimeUnit} from '../date-range-picker/models/types';

export const MultiAttributionLookbackSessions = 1;
export const DefaultMultiAttributionLookbackDays = 30;
export const MinMultiAttributionLookbackDays = 1;
export const MaxMultiAttributionLookbackDays = 90;
export const ReducedMaxMultiAttributionLookbackDays = 30;

export const DefaultMultiAttributionLookbackWindow: RelativeDate = {
  unit: TimeUnit.Day,
  value: DefaultMultiAttributionLookbackDays,
};
